import utils, {axiosWithAuth, deepCase} from '@imt/vue-toolbox/src/utils';
import Vue from 'vue';
import Vuex from 'vuex';

import {pagesToOptions} from '@/engine/blockly/dataFetchers';

import { createApiUrl } from '../../utilities';

Vue.use(Vuex);

export const authAxios = axiosWithAuth();

export const getters = {
    pageOptions(state) {
        return pagesToOptions(state.pages);
    },
};

export const actions = {
    async fetchClassCodes({commit}, {policySystemId, queryParams = {}}) {
        const url = createApiUrl(
                `${process.env.VUE_APP_ADMIN_URL_FORMS}/api/v1/policy-systems/${policySystemId}/class-codes/?include=versions`,
                queryParams
            ),
            response = await authAxios.get(url),
            classCodes = utils.dataFormatter.deserialize(response.data);

        commit('SET_EXPRESSION_BUILDER_DATA', {field: 'classCodes', data: classCodes});

        return classCodes;
    },
    async fetchForms({commit}, {policySystemId, queryParams = {}}) {
        const url = createApiUrl(
                `${process.env.VUE_APP_ADMIN_URL_FORMS}/api/v1/policy-systems/${policySystemId}/forms/?include=versions`,
                queryParams
            ),
            response = await authAxios.get(url),
            forms = utils.dataFormatter.deserialize(response.data);
        commit('SET_EXPRESSION_BUILDER_DATA', {field: 'forms', data: forms});

        return forms;
    },
    async fetchModel(_, {modelName}) {
        const response = await authAxios.get(`${process.env.VUE_APP_POLICY_DATA_URL}/api/v1/models/${modelName}/`);
        let names = deepCase(response.data, 'snake');

        return names;
    },
    async fetchPages({commit}, {policySystemId, queryParams = {}}) {
        const url = createApiUrl(
                `${process.env.VUE_APP_ADMIN_URL_CMS}/api/v1/policy-systems/${policySystemId}/pages/?include=versions`,
                queryParams
            ),
            response = await authAxios.get(url),
            pages = utils.dataFormatter.deserialize(response.data);

        commit('SET_EXPRESSION_BUILDER_DATA', {field: 'pages', data: pages});

        return pages;
    },
    async fetchPage({ commit, state }, { policySystemId, pageId, queryParams = {} }) {
        const url = createApiUrl(
                `${process.env.VUE_APP_ADMIN_URL_CMS}/api/v1/policy-systems/${policySystemId}/pages/${pageId}/?include=versions`,
                queryParams
            ),

            response = await authAxios.get(url),
            page = utils.dataFormatter.deserialize(response.data);

        commit('SET_EXPRESSION_BUILDER_DATA', {
            field: 'pages',
            data: [...state.pages, page]
        });

        return page;
    },
    async fetchUassists({commit}) {
        const response = await authAxios.get(`${process.env.VUE_APP_POLICY_DATA_URL}/api/v1/uassists/legacy/`);
        let uassists = deepCase(response.data);

        commit('SET_EXPRESSION_BUILDER_DATA', {field: 'uassists', data: uassists.data});

        return uassists;
    },
};

export const mutations = {
    SET_EXPRESSION_BUILDER_DATA(state, {field, data}) {
        state[field] = data;
    },
};

export const state = () => {
    return {
        classCodes: [],
        forms: [],
        pages: [],
        uassists: [],
    };
};

export default {
    actions,
    mutations,
    getters,
    namespaced: true,
    state: state()
};
